import React, { memo } from 'react';

import { useScopedTranslation } from '@common/utils/hooks/useScopedTranslation';
import {
  Timetable_timetable_groups as GroupType,
  Timetable_timetable_groups_rows_columns as Column,
} from '@typings/api';
import { times } from '@utils/array';

import Row from './Row';

interface Props {
  group: GroupType;
  onSlotSelect: (slot: Column) => void;
  timezone: string;
}

function Group(props: Props) {
  const { group, onSlotSelect, timezone } = props;
  const { t } = useScopedTranslation();

  if (group.rows.length === 0) {
    return null;
  }

  const totalColumns = group.rows[0].columns.length;

  return (
    <>
      <div className="flex mt-2 space-x-1 xl:space-x-2">
        {times(totalColumns).map((idx) => (
          <div
            className="flex-1 px-1 py-3 text-center border border-gray-300"
            key={idx}
          >
            {t(`main_form.timetable.${group.title}`)}
          </div>
        ))}
      </div>
      {group.rows.map((row) => (
        <Row
          key={row.startDate}
          onSlotSelect={onSlotSelect}
          row={row}
          timezone={timezone}
        />
      ))}
    </>
  );
}

export default memo(Group);
